module.exports = __webpack_public_path__ + "img/ic_add_red.9d677eec.svg";